import { useQuery } from '@tanstack/react-query'
import { getMyBonuses } from '@/api/services/bonuses.service'
import type { MyBonusListQuery } from '@/features/bonuses/types/bonus.types'

const myBonusesKeys = {
  list: (params?: MyBonusListQuery) => ['bonuses-me', params] as const,
}

export function useMyBonuses(params?: MyBonusListQuery) {
  return useQuery({
    queryKey: myBonusesKeys.list(params),
    queryFn: () => getMyBonuses(params),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  })
}
